<template lang="pug">
  div.subscribe-nav
    div.avatar-warpper
      img.avatar(:src="userinfo.headUrl",
        @error="imgError($event)")
      div.left-radius
        div.radius
      div.right-radius
        div.radius
    div.username {{userinfo.name}}
    div.vip(:class="{isVip: isVip}") {{levelName}}
    div.navs
      div.nav(v-for="(nav, i) in navs" :key="i" :class="{active: nav.key === $route.name}" @click.prevent="navigator(nav.key)")
        i(:class="nav.class")
        span {{nav.name}}
</template>

<script>
import { crisisNavigators } from '@index/config/config'
export default {
  name: 'SubscribeNav',
  data () {
    return {
      navs: crisisNavigators
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    userinfo () {
      return this.$store.state.user.userinfo
    },
    isVip () {
      return this.$store.getters.isVip
    },
    levelName () {
      return this.$store.getters.levelName
    }
  },
  methods: {
    imgError (e) {
      e.target.src = '/static/avatar.png'
    },
    navigator (key) {
      this.navs.forEach(d => {
        d.active = d.key === key
      })
      this.$router.push({name: key})
    }
  }
}
</script>

<style lang="scss" scoped>
  .subscribe-nav{
    width: 216px;
    margin-top: 42px;
    height: calc(100% - 92px);
    background-color: #fff;
    border-radius: 4px;
    position: relative;
    .avatar-warpper{
      width: 86px;
      position: absolute;
      left: 50%;
      height: 86px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      transform: translate(-50%, -50%);
      .avatar{
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 1px solid #dcdcdc;
      }
      .left-radius{
        position: absolute;
        left: 3px;
        bottom: 2.5px;
        transform: translate(-100%, -100%);
        width: 40px;
        height: 40px;
        background-color: #fff;
        .radius{
          width: 40px;
          height: 40px;
          background: #e8ebf1;
          border-radius: 0 0 20px 0;
        }
      }
      .right-radius{
        position: absolute;
        right: 3px;
        bottom: 2.5px;
        transform: translate(100%, -100%);
        width: 40px;
        height: 40px;
        background-color: #fff;
        .radius{
          width: 40px;
          height: 40px;
          background: #e8ebf1;
          border-radius: 0 0 0 20px;
        }
      }
    }
    .username{
      margin-top: 63px;
      font-size: 16px;
      color: #1b2c4d;
      text-align: center;
    }
    .vip{
      width: 80px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      background-color: #f3f3f3;
      border-radius: 13px;
      color: #666666;
      margin: 15px auto;
      &.isVip{
        background-color: #ffc884;
        color: #7c561e;
      }
    }
    .navs{
      margin-top: 30px;
      color: #333;
      .nav{
        height: 48px;
        line-height: 48px;
        cursor: pointer;
        i{
          margin-left: 28px;
        }
        span{
          margin-left: 10px;
        }
        &.active{
          background: #3989cb;
          color: #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/SubscribeNav.vue